const Purpose =Object.freeze([
    { key: 1, value: "Səyahət" },
    { key: 2, value: "Təhsil" },
    { key: 3, value: "İdman" },
    { key: 4, value: "Ekstremal" }
]);
  
export default Purpose;